import { render, staticRenderFns } from "./StoryList.vue?vue&type=template&id=887ef628"
import script from "./StoryList.vue?vue&type=script&lang=js"
export * from "./StoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports